export class Policy {
    id: number;
    referenceId: string;
    parentReferenceId: string;
    name: string;
    templateName: string;
    users: PolicyUser[] = [];
}

export class PolicyUser {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    status: string;
    lastUpdatedBy: string;
    dateOfDeactivation: string;
    lastUpdated: Date;
    roles: Role[];
}

class Role {
    id: number;
    name: string;
}